import React, { useState, useEffect } from 'react';
import AdminPanel from './AdminPannel';

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [isAddingUser, setIsAddingUser] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [userFields, setUserFields] = useState([
    { name: 'username', label: 'Username', type: 'text', required: true },
    { name: 'email', label: 'Email', type: 'email', required: true },
    {
      name: 'role',
      label: 'Role',
      type: 'select',
      options: [
        { value: 'user', label: 'User' },
        { value: 'admin', label: 'Admin' },
      ],
      required: true,
    },
    { name: 'isActive', label: 'Active', type: 'checkbox' },
    // Add more fields as needed
  ]);
  const [formData, setFormData] = useState(() =>
    userFields.reduce((acc, field) => ({ ...acc, [field.name]: field.type === 'checkbox' ? false : '' }), {})
  );

  useEffect(() => {
    // Mock user data
    const mockUsers = [
      { id: 'user1', username: 'johndoe', email: 'john.doe@example.com', role: 'admin', isActive: true },
      { id: 'user2', username: 'janesmith', email: 'jane.smith@example.com', role: 'user', isActive: true },
      { id: 'user3', username: 'peterpan', email: 'peter.pan@example.com', role: 'user', isActive: false },
    ];
    setUsers(mockUsers);
  }, []);

  const handleInputChange = (e, fieldName, type) => {
    const value = type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData(prevData => ({ ...prevData, [fieldName]: value }));
  };

  const handleAddUser = () => {
    if (editingUserId) {
      setUsers(prevUsers =>
        prevUsers.map(user => (user.id === editingUserId ? { ...user, ...formData } : user))
      );
      setEditingUserId(null);
    } else {
      setUsers(prevUsers => [...prevUsers, { id: crypto.randomUUID(), ...formData }]);
    }
    setIsAddingUser(false);
    setFormData(() =>
      userFields.reduce((acc, field) => ({ ...acc, [field.name]: field.type === 'checkbox' ? false : '' }), {})
    );
  };

  const handleEditUser = user => {
    setEditingUserId(user.id);
    setFormData({ ...user });
    setIsAddingUser(true);
  };

  const handleDeleteUser = id => {
    setUsers(prevUsers => prevUsers.filter(user => user.id !== id));
    if (editingUserId === id) {
      setEditingUserId(null);
      setIsAddingUser(false);
      setFormData(() =>
        userFields.reduce((acc, field) => ({ ...acc, [field.name]: field.type === 'checkbox' ? false : '' }), {})
      );
    }
  };

  const handleCancelAddUser = () => {
    setIsAddingUser(false);
    setEditingUserId(null);
    setFormData(() =>
      userFields.reduce((acc, field) => ({ ...acc, [field.name]: field.type === 'checkbox' ? false : '' }), {})
    );
  };

  return (
    <div style={{ display: 'flex' }}>
      <AdminPanel />
      <div style={{ marginLeft: 'auto', marginRight: 'auto', padding: '15px', backgroundColor: '#f9f9f9', width: 'calc(100% - 200px)' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#333' }}>User Manager</h1>

        {!isAddingUser && (
          <button
            onClick={() => setIsAddingUser(true)}
            style={{
              fontWeight: 'bold',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#3b82f6',
              color: '#fff',
              marginBottom: '15px',
            }}
          >
            <span style={{ marginRight: '8px', height: '16px', width: '16px' }}>+</span>Add New User
          </button>
        )}

        {isAddingUser && (
          <div
            style={{
              marginBottom: '20px',
              padding: '15px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06)',
              border: '1px solid #e5e7eb',
            }}
          >
            <h2 style={{ fontSize: '16px', fontWeight: 'semibold', marginBottom: '12px', color: '#333' }}>
              {editingUserId ? 'Edit User' : 'Add New User'}
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px' }}>
              {userFields.map(field => (
                <div key={field.name} style={{ marginBottom: '10px' }}>
                  <label
                    htmlFor={field.name}
                    style={{ display: 'block', fontSize: '14px', fontWeight: 'medium', color: '#4b5563', marginBottom: '5px' }}
                  >
                    {field.label}
                    {field.required && <span style={{ color: 'red' }}>*</span>}
                  </label>
                  {field.type === 'text' || field.type === 'email' ? (
                    <input
                      id={field.name}
                      type={field.type}
                      value={formData[field.name] || ''}
                      onChange={e => handleInputChange(e, field.name, field.type)}
                      style={{
                        marginTop: '4px',
                        width: 'calc(100% - 16px)',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #d1d5db',
                      }}
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                      required={field.required}
                    />
                  ) : field.type === 'select' ? (
                    <select
                      id={field.name}
                      value={formData[field.name] || field.options?.[0]?.value || ''}
                      onChange={e => handleInputChange(e, field.name, field.type)}
                      style={{
                        marginTop: '4px',
                        width: 'calc(100% - 16px)',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #d1d5db',
                        WebkitAppearance: 'none',
                        backgroundImage:
                          'url("data:image/svg+xml;charset=UTF-8,%3csvg fill=\'%234a5568\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3cpath d=\'M10 12l-5-5 1.414-1.414L10 9.172l3.586-3.586L15 7l-5 5z\'/%3e%3c/svg%3e")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right .5rem center',
                        backgroundSize: '1em',
                      }}
                      required={field.required}
                    >
                      {field.options &&
                        field.options.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </select>
                  ) : field.type === 'checkbox' ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          id={field.name}
                          checked={formData[field.name] || false}
                          onChange={e => handleInputChange(e, field.name, field.type)}
                          className="sr-only peer"
                          style={{}}
                        />
                        <div
                          style={{
                            width: '30px',
                            height: '16px',
                            backgroundColor: formData[field.name] ? '#3b82f6' : '#e5e7eb',
                            borderRadius: '8px',
                            position: 'relative',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease-in-out',
                          }}
                        >
                          <span
                            style={{
                              content: "''",
                              position: 'absolute',
                              width: '12px',
                              height: '12px',
                              backgroundColor: '#fff',
                              borderRadius: '50%',
                              top: '2px',
                              left: '2px',
                              transform: formData[field.name] ? 'translateX(14px)' : 'translateX(0)',
                              transition: 'transform 0.2s ease-in-out',
                            }}
                          ></span>
                        </div>
                        <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                          {field.label}
                        </span>
                      </label>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={handleCancelAddUser}
                style={{
                  fontWeight: 'bold',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#e5e7eb',
                  color: '#4b5563',
                }}
              >
                <span style={{ marginRight: '8px', height: '16px', width: '16px' }}>X</span>Cancel
              </button>
              <button
                onClick={handleAddUser}
                style={{
                  fontWeight: 'bold',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#4caf50',
                  color: '#fff',
                }}
              >
                <span style={{ marginRight: '8px', height: '16px', width: '16px' }}>💾</span>
                {editingUserId ? 'Update User' : 'Add User'}
              </button>
            </div>
          </div>
        )}

        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06)',
            border: '1px solid #e5e7eb',
            overflowX: 'auto',
          }}
        >
          <h2
            style={{
              padding: '10px 12px',
              textAlign: 'left',
              fontSize: '12px',
              fontWeight: 'medium',
              color: '#6b7280',
              textTransform: 'uppercase',
              letterSpacing: '0.025em',
            }}
          >
            User List
          </h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f9fafb' }}>
                <tr>
                  {userFields.map(field => (
                    <th
                      key={field.name}
                      style={{
                        padding: '10px 12px',
                        textAlign: 'left',
                        fontSize: '12px',
                        fontWeight: 'medium',
                        color: '#6b7280',
                        textTransform: 'uppercase',
                        letterSpacing: '0.025em',
                      }}
                    >
                      {field.label}
                    </th>
                  ))}
                  <th
                    style={{
                      padding: '10px 12px',
                      textAlign: 'right',
                      fontSize: '12px',
                      fontWeight: 'medium',
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      letterSpacing: '0.025em',
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    {userFields.map(field => (
                      <td
                        key={field.name}
                        style={{ padding: '8px 12px', whiteSpace: 'nowrap', fontSize: '14px', color: '#374151' }}
                      >
                        {field.type === 'checkbox' ? (
                          user[field.name] ? 'Active' : 'Inactive'
                        ) : (
                          user[field.name]
                        )}
                      </td>
                    ))}
                    <td style={{ padding: '8px 12px', whiteSpace: 'nowrap', fontSize: '14px', color: '#374151', textAlign: 'right' }}>
                      <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                        <button
                          onClick={() => handleEditUser(user)}
                          style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #3b82f6',
                            color: '#3b82f6',
                            padding: '5px 7px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'bold',
                          }}
                        >
                          <span style={{ marginRight: '4px', height: '16px', width: '16px' }}>✏️</span>
                          <span style={{ fontWeight: 'bold' }}>Edit</span>
                        </button>
                        <button
                          onClick={() => handleDeleteUser(user.id)}
                          style={{
                            backgroundColor: 'transparent',
                            border: '1px solid #dc2626',
                            color: '#dc2626',
                            padding: '5px 7px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'bold',
                          }}
                        >
                          <span style={{ marginRight: '4px', height: '16px', width: '16px' }}>🗑️</span>
                          <span style={{ fontWeight: 'bold' }}>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {users.length === 0 && (
                  <tr>
                    <td colSpan={userFields.length + 1} style={{ textAlign: 'center', padding: '10px', color: '#718096' }}>
                      No users available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManager;